import LineChart from "components/charts/LineChart";

const chartOptions = {
    chart: {
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: false,
        },
    },
    markers: {
        size: 0,
        colors: "white",
        strokeColors: "#7551FF",
        strokeWidth: 3,
        strokeOpacity: 0.9,
        strokeDashArray: 0,
        fillOpacity: 1,
        // discrete: [],
        shape: "circle",
        radius: 2,
        offsetX: 0,
        offsetY: 0,
        showNullDataPoints: true,
    },
    tooltip: {
        theme: "dark",
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "smooth",
        type: "line",
        width: [5, 3],
        dashArray: [0, 8],
    },
    xaxis: {
        type: "numeric",
        categories: ["SEP", "OCT", "NOV", "DEC", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG"],
        labels: {
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        type: "numeric",
        labels: {
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
    },
    legend: {
        show: true,
        horizontalAlign: 'left',
        markers: {
            offsetX: -5,
            strokeWidth: 0,
            size: 5,
        },
        labels: {
            colors: ['#A3AED0', '#A3AED0']
        },
        itemMargin: {
            horizontal: 15,
        },
    },
    grid: {
        show: false,
    }
};

const chartData = [
    {
      name: "This year",
      data: [50, 64, 48, 66, 49, 68, 50, 64, 48, 66, 49, 68],
    },
    {
      name: "Last year",
      data: [30, 40, 24, 46, 20, 46, 30, 40, 24, 46, 20, 46],
    },
];

function AttendanceLevel() {
    const newOptions = {
        ...chartOptions,
        colors: ["#6DA38C", "#CED7EE"],
    };

    return (
        <>
            <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* header */}
                <div className="flex">
                    <div className="flex-1">
                        <p className="text-gray-800 font-bold dark:text-white">Attendance level</p>
                        <p className="text-gray-600 text-sm">Member attendance level over time</p>
                    </div>
                    {/* <div>
                        <select className="bg-[transparent] h-12 text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
                            <option>All users</option>
                        </select>
                    </div> */}
                </div>

                {/* chart */}
                <div className="block h-[300px]">
                    <div className="h-full w-full">
                        <LineChart
                            chartData={chartData}
                            chartOptions={newOptions}
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default AttendanceLevel;
